/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.0804.1175c-1.0895-.182-2.1202.5537-2.3021 1.6432l-1.177 7.0477c-.273 1.6342.8306 3.1803 2.4649 3.4532l2.595.4334c.7464.1246 1.453-.3781 1.5799-1.1242l.2885-1.6964 11.771 1.9657c.9532.1592 1.8551-.4845 2.0143-1.4378l.1647-.9863c.1592-.9533-.4845-1.8552-1.4378-2.0144L10.2841 5.4381l.1339-.7872a.3251.3251 0 0 0-.267-.3752C9.2372 4.1231 8.6175 3.262 8.7632 2.347L9.0267.6914a.0813.0813 0 0 0-.067-.093L6.0805.1174Zm2.699 5.222C7.7026 4.688 7.072 3.4292 7.2817 2.1112l.0422-.2651-1.4907-.249a.5.5 0 0 0-.5755.4108l-1.177 7.0477c-.1365.8171.4153 1.5901 1.2324 1.7266l2.4703.4125.9958-5.855Zm1.2532 1.5773-.2515 1.4788 11.7665 1.965a.25.25 0 0 0 .2878-.2054l.1647-.9863a.25.25 0 0 0-.2054-.2878L10.0326 6.9168Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.8019 12.1856a.7554.7554 0 0 0 .6981.8085c1.9383.1421 2.8719.3391 4.0235.8996 1.2172.5924 1.5974 1.1979 1.5974 1.5962 0 .2203-.1052.5007-.4443.8308-.3414.3324-.8747.6665-1.5952.9632-1.4375.5919-3.4755.9756-5.7656.9756-2.29 0-4.3281-.3837-5.7656-.9756-.7205-.2967-1.2538-.6308-1.5952-.9632-.3391-.3301-.4443-.6105-.4443-.8308 0-.3657.3165-.9121 1.3556-1.4724a.7554.7554 0 0 0-.717-1.3297C.9895 13.3133 0 14.2485 0 15.4899c0 .068.003.1352.009.2014H0v3.9725c0 .7565.3697 1.4095.897 1.9309.5244.5187 1.2448.951 2.0742 1.298C4.6332 23.5879 6.8768 24 9.3157 24c2.439 0 4.6826-.4121 6.3446-1.1073.8294-.347 1.5498-.7793 2.0743-1.298.5272-.5214.8969-1.1744.8969-1.9309v-3.9725h-.009a2.2686 2.2686 0 0 0 .009-.2014c0-1.3362-1.141-2.3189-2.4469-2.9545-1.3715-.6675-2.5052-.8962-4.5742-1.0479a.7553.7553 0 0 0-.8086.6981ZM2.975 18.6808c-.5427-.2235-1.039-.4831-1.4643-.7792v1.7622c0 .2324.1094.5214.4485.8568.3419.3381.8752.6774 1.595.9784 1.4362.6008 3.4728.9903 5.7616.9903 2.2888 0 4.3254-.3895 5.7617-.9903.7197-.301 1.253-.6403 1.5949-.9784.3391-.3354.4485-.6244.4485-.8568v-1.7622c-.4253.2961-.9216.5557-1.4644.7792-1.6608.6839-3.903 1.0893-6.3407 1.0893s-4.68-.4054-6.3408-1.0893Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuBuild'
);
